var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Dummy page")]),_c('BriqPanel',[_c('h2',[_vm._v("dummy content")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }